import React, { Component } from "react";
import styled from "styled-components";
import { graphql } from "react-apollo";
import { observer } from "mobx-react";
import {
  queryGetCaseAggregateCount,
  subsOnCaseAggregateCountUpdated
} from "Apollo";
import { CaseManagementStore, ChangeTab, IsAgentAllowedToAssignToOther } from "Store";
import Tab from "./Tab";
import { CurrentTheme } from "theme";

export default graphql(queryGetCaseAggregateCount)(
  observer(
    class Header extends Component {
      componentWillReceiveProps(nextProps) {
        const { selectedTab } = CaseManagementStore;
        const prevData = this.props.data.getCaseAggregateCount;
        const nextData = nextProps.data.getCaseAggregateCount;

        // check if there is change of counter
        if (prevData && nextData) {
          // check all count and notify if changed
          if (
            selectedTab !== "all" &&
            prevData.allCount !== nextData.allCount
          ) {
            CaseManagementStore.notifAllCase = true;
          }

          // check my count and notify if changed
          if (
            selectedTab !== "my" &&
            (prevData.assignedToCount !== nextData.assignedToCount ||
              prevData.lastReplyCount !== nextData.lastReplyCount)
          ) {
            CaseManagementStore.notifMyCase = true;
          }

          // check pending count and notify if changed
          if (
            selectedTab !== "pending" &&
            prevData.pendingApprovalCount !== nextData.pendingApprovalCount
          ) {
            CaseManagementStore.notifPendingCase = true;
          }
        }

        // update title
        if(nextData) {
          document.title = `(${nextData.lastReplyCount}/${
            nextData.assignedToCount
          }) ${CurrentTheme.title}`;
        }        
      }

      componentWillMount() {
        this.props.data.subscribeToMore({
          document: subsOnCaseAggregateCountUpdated,
          updateQuery: (prevResult, { subscriptionData }) => {
            if (!subscriptionData) return prevResult;
            const result = Object.assign({}, prevResult, {
              getCaseAggregateCount:
                subscriptionData.data.onCaseAggregateCountUpdated
            });
            return result;
          }
        });
      }

      render() {
        const {
          selectedTab,
          allCaseSortAsc,
          myCaseSortAsc,
          pendingSortAsc,
          notifAllCase,
          notifMyCase,
          notifPendingCase
        } = CaseManagementStore;
        const showAllTab = true
        const data = this.props.data.getCaseAggregateCount;
        let assignedToCount = 0;
        let lastReplyCount = 0;
        let allCount = 0;
        let pendingApprovalCount = 0;
        if (data) {
          assignedToCount = data.assignedToCount;
          lastReplyCount = data.lastReplyCount;
          allCount = data.allCount;
          pendingApprovalCount = data.pendingApprovalCount;
        }
        console.log('show all tab', showAllTab)
        return (
          <Wrapper>
            {showAllTab && <Tab
              key="all"
              name="ALL"
              total={allCount}
              notification={selectedTab !== "all" && notifAllCase}
              sortAsc={allCaseSortAsc}
              selected={selectedTab === "all"}
              onClick={() => ChangeTab("all")}
              onSortClick={() => {
                CaseManagementStore.allCaseSortAsc = !allCaseSortAsc;
              }}
            />}
            <Tab
              key="mycase"
              name="My Case"
              replied={lastReplyCount}
              total={assignedToCount}
              notification={selectedTab !== "my" && notifMyCase}
              sortAsc={myCaseSortAsc}
              selected={selectedTab === "my"}
              onClick={() => ChangeTab("my")}
              onSortClick={() =>
                (CaseManagementStore.myCaseSortAsc = !myCaseSortAsc)
              }
            />
            <Tab
              key="pendingcase"
              name="My Approval"
              total={pendingApprovalCount}
              notification={selectedTab !== "pending" && notifPendingCase}
              sortAsc={pendingSortAsc}
              selected={selectedTab === "pending"}
              onClick={() => ChangeTab("pending")}
              onSortClick={() =>
                (CaseManagementStore.pendingSortAsc = !pendingSortAsc)
              }
            />
          </Wrapper>
        );
      }
    }
  )
);

const Wrapper = styled.div`
  flex: none;
  border-bottom: 1px solid ${props => props.theme.panelBorder};
  display: flex;
  & > div:first-child {
    border-right: 1px solid ${props => props.theme.panelBorder};
    border-radius: 4px 0 0 0;
  }
`;



// WEBPACK FOOTER //
// ./src/module-case-management/list-panel/header/HeaderWithStoreQuery.js